import { fetchData, postData } from 'modules/Axios';
import { showToast } from 'modules/Notifications';

export const defaultState = {
  integration: null,
  integrationTypes: {},
};

export const CREATE_INTEGRATION = 'CREATE_INTEGRATION';

export const createIntegration = integration => ({
  type: CREATE_INTEGRATION,
  payload: integration,
});

export const saveIntegration = (integrationDTO) => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    const integration = await dispatch(postData(`brands/${brand.id}/integrations`, { ...integrationDTO }))
      .then((result) => {
        dispatch(showToast({
          state: 'SUCCESS',
          title: 'Success',
          message: 'Integration Created Successfully',
          dismissible: true,
          dismissAfter: 2000,
        }));
        return result;
      })
      .catch(e => {
        console.log('API Call to create integration failed...', e);
        dispatch(showToast({
          state: 'ERROR',
          title: 'Error',
          message: 'Issue creating the integration. Please try again later',
          dismissible: true,
          dismissAfter: 1500,
        }));
        return null;
      });

    return integration;
  };
};

export const RECEIVE_INTEGRATION_TYPES = 'RECEIVE_INTEGRATION_TYPES';

export const receiveIntegrationTypes = payload => ({
  type: RECEIVE_INTEGRATION_TYPES,
  payload
});

export const GET_INTEGRATION_TYPES = 'GET_INTEGRATION_TYPES';

export const getIntegrationTypes = () => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    const URL = `/brands/${brand.id}/audiences/destinations`;
    try {
      const destinations = await dispatch(fetchData(URL));
      dispatch(receiveIntegrationTypes(destinations));
    } catch (e) {
      console.log('API Call to /integrationTypes failed...', e);
      dispatch(showToast({
        state: 'ERROR',
        title: 'Error',
        message: 'Issue retrieving integration types list. Please try again later',
        dismissible: true,
        dismissAfter: 1500,
      }));
    }
  };
};

export const saveSshFile = (fileData, updateFileUploadingProgress) => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    try {
      const getSshKeyId = await dispatch(postData(`brands/${brand.id}/integrations/ssh_keys`, fileData, null, true, 'json', updateFileUploadingProgress));
      return getSshKeyId;
    } catch (e) {
      console.log('API Call to upload audience file failed...', e);
      dispatch(showToast({
        state: 'ERROR',
        title: 'Error',
        message: 'Issue uploading audience file. Please try again later',
        dismissible: true,
        dismissAfter: 1500,
      }));
      return null;
    }
  };
};

export const saveEncryptionFile = (fileData, updateFileUploadingProgress) => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    try {
      const getEncryptionKeyId = await dispatch(postData(`brands/${brand.id}/integrations/encryption_keys`, fileData, null, true, 'json', updateFileUploadingProgress));
      return getEncryptionKeyId;
    } catch (e) {
      console.log('API Call to upload audience file failed...', e);
      dispatch(showToast({
        state: 'ERROR',
        title: 'Error',
        message: 'Issue uploading audience file. Please try again later',
        dismissible: true,
        dismissAfter: 1500,
      }));
      return null;
    }
  };
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case CREATE_INTEGRATION:
      return {
        ...state,
        integration: action.payload.integration,
      };
    case RECEIVE_INTEGRATION_TYPES:
      return {
        ...state,
        integrationTypes: action.payload,
      };
    default:
      return state;
  }
}
